import React from "react"

const CampingIcon = ({ size }) => (
  <svg
    height={size}
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 61 61"
    fill="currentColor"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="030---Camping" transform="translate(-1 -1)">
      <path
        id="Shape"
        d="m1.07 60.345c.09369449.2751898.30981022.4913055.585.585.315.117 58.4.108 58.69 0 .1345359-.0479366.2575182-.1235655.361-.222.4-.4.294-.455.294-6.708 0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.235l-14-24.5v-3.735c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v3h-24v-3c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v3.735l-14 24.5v-2.235c0-.5522847-.44771525-1-1-1s-1 .4477153-1 1c0 6.56-.029 6.079.07 6.345zm17.93-1.345v-23.234l13.276 23.234zm24.42-26 14.856 26h-23.276v-5c0-.5522847-.4477153-1-1-1s-1 .4477153-1 1v2.235l-13.277-23.235zm-26.42 2.766v23.234h-13.276z"
      />
      <path
        id="Shape"
        d="m25 37h1c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-1c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
      />
      <path
        id="Shape"
        d="m30 37h12c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1h-12c-.5522847 0-1 .4477153-1 1s.4477153 1 1 1z"
      />
      <path
        id="Shape"
        d="m15.475 17.144c.4682098-.3654942.6453159-.992412.4375599-1.5488686-.207756-.5564565-.7523828-.9139115-1.3455599-.8831314-2.0178095.0406034-3.8264248-1.2388095-4.46-3.155-.5236357-1.4534074-.29678566-3.07155415.6063195-4.32494495.9031051-1.25339079 2.3662579-1.98074488 3.9106805-1.94405505.582392.00411108 1.1029522-.36253972 1.2952397-.91228771.1922875-.54974798.0137464-1.1609262-.4442397-1.52071229-3.703017-2.83678644-8.95977267-2.37409399-12.11031309 1.06593321s-3.15054042 8.71710639 0 12.15713359 8.40729609 3.9027196 12.11031309 1.0659332zm-12.423-7.962c.26724932-2.17602527 1.53479787-4.10262974 3.42732879-5.20935233 1.89253093-1.10672258 4.19315721-1.26673113 6.22067121-.43264767-6.456 1.8-6.45 11.122.009 12.914-2.2949623.951568-4.92205588.6182849-6.90670128-.8762104-1.9846454-1.4944954-3.03077318-3.9272541-2.75029872-6.3957896z"
      />
      <path
        id="Shape"
        d="m46 1c-.5522847 0-1 .44771525-1 1v2c0 .55228475.4477153 1 1 1s1-.44771525 1-1v-2c0-.55228475-.4477153-1-1-1z"
      />
      <path
        id="Shape"
        d="m46 11c.5522847 0 1-.4477153 1-1v-2c0-.55228475-.4477153-1-1-1s-1 .44771525-1 1v2c0 .5522847.4477153 1 1 1z"
      />
      <path
        id="Shape"
        d="m48 7h2c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1h-2c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1z"
      />
      <path
        id="Shape"
        d="m44 5h-2c-.5522847 0-1 .44771525-1 1s.4477153 1 1 1h2c.5522847 0 1-.44771525 1-1s-.4477153-1-1-1z"
      />
      <path
        id="Shape"
        d="m40.707 17.293c-.3904999-.3903819-1.0235001-.3903819-1.414 0l-1.5 1.5c-.2599566.2510745-.3642126.6228779-.2726972.9725073.0915155.3496295.3645604.6226744.7141899.7141899.3496294.0915154.7214328-.0127406.9725073-.2726972l1.5-1.5c.3903819-.3904999.3903819-1.0235001 0-1.414z"
      />
      <path
        id="Shape"
        d="m34.793 21.793-1.5 1.5c-.3789722.3923789-.3735524 1.0160848.0121814 1.4018186s1.0094397.3911536 1.4018186.0121814l1.5-1.5c.3789722-.3923789.3735524-1.0160848-.0121814-1.4018186s-1.0094397-.3911536-1.4018186-.0121814z"
      />
      <path
        id="Shape"
        d="m39.207 21.793c-.3923789-.3789722-1.0160848-.3735524-1.4018186.0121814s-.3911536 1.0094397-.0121814 1.4018186c1.607 1.606 1.676 1.793 2.207 1.793.4043959-.0000863.7689341-.2437275.923678-.6173454.1547439-.373618.0692299-.8036603-.216678-1.0896546z"
      />
      <path
        id="Shape"
        d="m36.207 18.793-1.5-1.5c-.3923789-.3789722-1.0160848-.3735524-1.4018186.0121814s-.3911536 1.0094397-.0121814 1.4018186l1.5 1.5c.3923789.3789722 1.0160848.3735524 1.4018186-.0121814s.3911536-1.0094397.0121814-1.4018186z"
      />
      <path
        id="Shape"
        d="m35 10c0-.55228475-.4477153-1-1-1-2.757 0-5-3.14-5-7 0-.55228475-.4477153-1-1-1s-1 .44771525-1 1c0 3.86-2.243 7-5 7-.5522847 0-1 .44771525-1 1 0 .5522847.4477153 1 1 1 2.757 0 5 3.14 5 7 0 .5522847.4477153 1 1 1s1-.4477153 1-1c0-3.86 2.243-7 5-7 .5522847 0 1-.4477153 1-1zm-7 3.368c-.6081975-1.3558585-1.5745054-2.5202681-2.795-3.368 1.2204946-.84773187 2.1868025-2.01214153 2.795-3.368.6095749 1.35647416 1.5776641 2.52094709 2.8 3.368-1.2223359.8470529-2.1904251 2.0115258-2.8 3.368z"
      />
      <path
        id="Shape"
        d="m48 19c2.757 0 5 3.14 5 7 0 .5522847.4477153 1 1 1s1-.4477153 1-1c0-3.86 2.243-7 5-7 .5522847 0 1-.4477153 1-1s-.4477153-1-1-1c-2.757 0-5-3.14-5-7 0-.55228475-.4477153-1-1-1s-1 .44771525-1 1c0 3.86-2.243 7-5 7-.5522847 0-1 .4477153-1 1s.4477153 1 1 1zm6-4.368c.6095749 1.3564742 1.5776641 2.5209471 2.8 3.368-1.2223359.8470529-2.1904251 2.0115258-2.8 3.368-.6081975-1.3558585-1.5745054-2.5202681-2.795-3.368 1.2204946-.8477319 2.1868025-2.0121415 2.795-3.368z"
      />
    </g>
  </svg>
)

export default CampingIcon
